import classNames from 'classnames';
import React from 'react';
import { useDrop } from 'react-dnd';
import * as styles from './TopicTreeCardDropSeparator.module.scss';
import type { ContentMapDropParams } from '../utils/types';

type TopicTreeCardDropSeparatorProps = ContentMapDropParams;

const TopicTreeCardDropSeparator = (
  dropParams: TopicTreeCardDropSeparatorProps,
) => {
  const [{ isOver, isDragging }, dropRef] = useDrop(dropParams);

  return (
    <div className={styles.container}>
      {isOver && <div className={styles.overIndicator} />}
      <div
        ref={dropRef}
        className={classNames(styles.drop, {
          [styles.isDragging]: isDragging,
        })}
      />
    </div>
  );
};

export default TopicTreeCardDropSeparator;
